<template>
    <ag-grid-vue v-if="columnDefs"
                 id="trailList"
                 style="width: 100%; height: 100%"
                 paginationAutoPageSize=true
                 :sortingOrder="['asc','desc']"
                 suppressCellSelection
                 immutableData
                 animateRows
                 :pagination="true"
                 rowSelection="single"
                 class="ag-theme-material"
                 :columnDefs="columnDefs"
                 :rowData="trailsForGrid"
                 @first-data-rendered="onFirstDataRendered"
                 @grid-ready="onGridReady"
                 @row-clicked="rowClicked"
                 :getRowNodeId="getRowNodeId"  >
    </ag-grid-vue>
</template>
<script>
  import {AgGridVue} from "@ag-grid-community/vue";
  import HasherDao from "../daos/HasherDao";
  import strings from "../strings.js";

  let dateComparator = function(date1, date2) {
    if (date1 === null && date2 === null) {
      return 0;
    } else if (date1 === null) {
      return -1;
    } else if (date2 === null) {
      return 1;
    } else {
      return Date.parse(date1) - Date.parse(date2);
    }
  };
  export default {
    name: 'TrailList',
    props: ['trails', 'selectedTrail'],
    components: {
      AgGridVue
    },
    computed: {
      columnDefs: function () {
        if (!this.$strings["trailList.table.hares"]) {
          return null;
        } else {
          return [
            {headerName: '#', field: 'trailOrdinal', sort: 'asc', sortable: true, width: 70, suppressSizeToFit  : true},
            {headerName: 'Date', field: 'trailDate', sortable: true, width: 125, comparator: dateComparator, suppressSizeToFit : true},
            {headerName: strings["trailList.table.hares"], field: 'hareIds', tooltipField: 'hares', sortable: true, width: 160, suppressSizeToFit : true, valueGetter : params => {
                return params.data.hareIds.map(id => this.haresById[id]).join(', ');
              }
            },
            {headerName: strings["trailList.table.pack"], sortable: true, width: 75, suppressSizeToFit : true, valueGetter : params => {
                return params.data.hasherIds.length;
              }
            },
            {headerName: 'Location', field: 'trailLocation', tooltipField: 'trailLocation', sortable: true, width: 75, minWidth: 75 },
          ]
        }
      },
      trailsForGrid: {
        deep: true,
        get: function() {
          console.log(this.trails);
          //Don't send empty list to ag-grid as itll think we're done loading
          if (!this.trails || (this.trails && this.trails.length === 0)) {
            return undefined;
          } else {
            return this.trails;
          }
        }
      }
    },
    data: function () {
      return {
        haresById: {},
        defaultColDef: {
          resizable: true,
        }
      }
    },
    beforeMount: function () {
      this.computeTrailFields();
    },
    methods : {
      getRowNodeId: function(row) {
        return row.id;
      },
      onGridReady: function(grid) {
        this.gridApi = grid.api;
        this.gridApi.refreshCells();
      },
      onFirstDataRendered: function (grid) {
        this.gridApi = grid.api;
        this.gridApi.refreshCells();
        this.dataRendered = true;
        this.selectedTrail && this.selectTrailRow(this.selectedTrail.id);
        this.resizeColumns = grid.api.sizeColumnsToFit.bind(grid.api);
        this.resizeColumns();
        new ResizeObserver(this.resizeColumns).observe(this.$el);
      },
      rowClicked: function(row) {
        this.$emit("selectTrailId", row.data.id);
      },
      selectTrailRow(id) {
        let node = this.gridApi.getRowNode(id);
        if (!this.dataRendered) {
          //Data might not be ready yet. onFirstDataRendered hasn't fired yet, and will select the row for us.
        } else if (id === "new") {
          //Creating a new trail, nothing to select
        } else if (!node) {
          console.log("Error: table node for id " + id + " doesn't exist");
        } else {
          let rowNode = this.gridApi.getRowNode(id);
          //this.gridApi.paginationGoToPage();
          rowNode.setSelected(true, true);
          this.gridApi.ensureNodeVisible(node);
        }
      },
      computeTrailFields: function() {
        let trails = this.trails;
        if (trails && trails.length) {
          HasherDao.fetchByIds(trails.map(trail => trail.hareIds).flat())
            .then(hashers => {
              hashers.forEach(hare => this.haresById[hare.id] = hare.hash_name)
              if (this.gridApi) {
                //update grid if it's already been drawn - needed if this completes before grid is ready, usually because the hares/hashers are already in the cache
                // this.gridApi.refreshCells({columns: ["packSize", "hares"], force: true});

                this.gridApi.refreshCells();
              }
            });
        }
      }
    },
    watch: {
      trails: function () {
        this.computeTrailFields();
      },
      selectedTrail : function() {
        this.selectTrailRow(this.selectedTrail.id);
      }
    }
  }
</script>
<style  lang="scss">
    #trailList .ag-header-cell-label,
    #trailList .ag-header-cell-label > .ag-header-cell-text {
        overflow: visible;
    }
   /*fix mysterious horizontal scrollbar caused by ag-grid https://github.com/ag-grid/ag-grid/issues/2911*/
    #trailList  .ag-body-viewport {
        //seems to help in chrome, but not firefox
     //   height: auto;
    }
    #trailList .ag-center-cols-viewport {
        //Remove if firefox specific fix found, or ag-grid fixes the bug
       // overflow:hidden;
    }

</style>
